import React from "react";
import { JIDOU_SERVICES, SHOUGAI_SERVICES } from "./constants";

export default function ChiikiDetailDialog({ type, onClose }) {
  if (!type) {
    return null;
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const dialogClassName =
    type === "law" ? "dialog dialog-law" : "dialog dialog-keika";

  return (
    <div className="dialog-overlay" onClick={handleOverlayClick}>
      <div className={dialogClassName} role="dialog" aria-modal="true">
        <button
          type="button"
          className="dialog-close"
          onClick={onClose}
          aria-label="閉じる"
        >
          ×
        </button>
        {type === "law" && <LawDialogContent />}
        {type === "keika" && <KeikaDialogContent />}
      </div>
    </div>
  );
}

function LawDialogContent() {
  return (
    <>
      <div>サービス種類ごとに法区分を選択して下さい。</div>
      <div>
        <table>
          <tbody>
            <tr>
              <td className="name">児童福祉法</td>
              <td className="value">
                {JIDOU_SERVICES.map((service) => (
                  <React.Fragment key={service}>
                    {service}
                    <br />
                  </React.Fragment>
                ))}
              </td>
            </tr>
            <tr>
              <td className="name">障害者総合支援法</td>
              <td className="value">
                {SHOUGAI_SERVICES.map((service) => (
                  <React.Fragment key={service}>
                    {service}
                    <br />
                  </React.Fragment>
                ))}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

function KeikaDialogContent() {
  return (
    <div>
      <div>次の場合に経過措置に「あり」を選択してください。</div>
      <div>
        ○平成２４年４月に障害児施設から経過的施設入所支援、経過的生活介護に移行したとき
      </div>
    </div>
  );
}
